export const dummyRoutes = {
  result: {
    data: [
      {
        id: 1,
        routeStop: "Sector 21 Bus Stop",
        landmark: "Near HDFC Bank", // ✅ NEW
        captain: "Ravi Kumar",
        createdOn: "21/03/2026",
        status: 1,
        lat: 28.6139,
        lng: 77.209,
      },
      {
        id: 2,
        routeStop: "MG Road Metro",
        landmark: "Opposite Mall", // ✅ NEW
        captain: "Amit Sharma",
        createdOn: "20/03/2026",
        status: 0,
        lat: 28.4595,
        lng: 77.0266,
      },
    ],
    total: 2,
  },
};